<template>
  <ComplexCard
    :id="partnerKey"
    class="min-w-[212px]"
    variant="small"
    :headerImageUrl="headerImageUrl"
    :title="title"
    :detailsUrl="detailsUrl"
    :firstLineText="firstLineText"
    :secondLineText="secondLineText"
    openInNewWindow
    tallHeader
    @ctaClicked="ctaClicked"
  />
</template>

<script lang="ts">
import ComplexCard from '@/components/complex_card/ComplexCard.vue';

export default {
  name: 'BHPartnerCard',
  components: {
    ComplexCard,
  },
  props: ['observer', 'headerImageUrl', 'title', 'detailsUrl', 'firstLineText', 'secondLineText', 'partnerKey'],
  mounted() {
    this.observer.observe(this.$el);
  },
  methods: {
    ctaClicked() {
      this.$emit('ctaClicked', this.partnerKey);
    },
  },
};
</script>
